import React from 'react'
import * as PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icon/Icon'
import content from '../../../../redux/reducer/content'
import { useDispatch } from 'react-redux'
import { useTranslation } from '../../../../translations'
import { useModal } from '../../../../hooks/useModal'
import useStateControls from '../../../../hooks/useStateControls'
import {
  ONBOARDING_STEPS_TYPES,
  useOnboardingContext,
} from '../../../../providers/onboarding-provider'
import { defaultLanguage, defaultStore } from '../../../../translations'
import { getConfig } from '../../../../utils/getConfig'
import { useService } from '../../../../redux/reducer/service'

export default function CustomMenuItem(props) {
  const { linkAttr, img, icon, iconM, text, className, attr, index, action, id } = props
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { addModal } = useModal()
  const { setState } = useStateControls()

  const { isRules, ...otherAttrs } = linkAttr ?? {}

  // Временное решение с ссылкой на статичный pdf файл для "Условия акции" в меню.
  // Ранее ссылка на pdf файл приходила с бэкенда:
  // const { pdf } = useContent()
  const { tamagotchiUrl } = getConfig()
  const { serviceData } = useService()

  const getStaticPdf = () => {
    const currentLanguage = serviceData?.lang || defaultLanguage
    return `${tamagotchiUrl}/docs/rules_${defaultStore}_${currentLanguage}.pdf`
  }

  const staticPdf = getStaticPdf()

  const formattedLinkAttr = isRules
    ? { ...otherAttrs, href: staticPdf }
    : { ...otherAttrs, href: t(otherAttrs.href, { defaultValue: otherAttrs.href }) }

  const Tag = linkAttr ? 'a' : 'div'

  const speciallyCallback = {
    restartTutorial() {
      setState('main')
    },
  }

  const { openOnboardingModal } = useOnboardingContext()

  const onClick = () => {
    if (typeof speciallyCallback?.[id] === 'function') speciallyCallback?.[id]?.()

    if (attr?.modal) {
      const modals = Array.isArray(attr.modal) ? attr.modal : [attr.modal]
      modals.forEach((modalData) => addModal(modalData))
    }

    if (attr?.tutorial) {
      openOnboardingModal(ONBOARDING_STEPS_TYPES.START)
    }
  }

  return (
    <li
      className={classNames('custom-menu__item custom-menu__item_' + index, className)}
      {...attr}
      onClick={onClick}
    >
      <Tag
        {...formattedLinkAttr}
        className={'custom-menu__item-inner'}
        onClick={() => action && dispatch(content.actions[action]?.())}
      >
        {icon && (
          <div className='custom-menu__item-icon custom-menu__item-icon_desktop'>
            <Icon name={icon} />
          </div>
        )}
        <div className='custom-menu__item-icon custom-menu__item-icon_mobile'>
          <Icon name={iconM} />
        </div>
        {img && (
          <img
            src={img}
            className={'custom-menu__item-image'}
            alt={'custom-menu__item-image'}
          />
        )}
        <span className={'custom-menu__item-text'}>{t(text)}</span>
      </Tag>
    </li>
  )
}

CustomMenuItem.propTypes = {
  className: PropTypes.string,
  attr: PropTypes.object,
  href: PropTypes.string,
  text: PropTypes.string,
}
